module.exports = __webpack_public_path__ + "img/daiquiri.12264be4.jpg";